import { useState } from 'react';
import { PostHelpArticleFeedback } from '@/apis/helpCenterAPI';
import { AiStar } from '@/assets/icons/icons';
import { useToken } from '@/common/helper';
import type { HelpArticleFeedbackProps, HelpArticleVote } from '../../types';
import styles from '../../AppHelpCenter.module.scss';
import HelpVoteButtons from '../HelpVoteButtons/HelpVoteButtons';

const HelpArticleFeedback = ({
  articleId,
  articleTitle,
  initialVote,
  onAskAssistant,
  aiEnabled,
}: HelpArticleFeedbackProps) => {
  const { token } = useToken();
  const [vote, setVote] = useState<HelpArticleVote | undefined>(
    initialVote ?? undefined
  );

  // Updates the button right away; a repeat click on the same vote sends nothing.
  const handleVote = (value: HelpArticleVote) => {
    if (value === vote) return;
    const previous = vote;
    setVote(value);
    PostHelpArticleFeedback(token, articleId, { value }).catch(() =>
      setVote(previous)
    );
  };

  return (
    <div className={styles.articleFeedbackWrap}>
      <div className={styles.articleFeedback}>
        <span className={styles.articleFeedbackTitle}>
          {vote === 'down' && aiEnabled
            ? 'Thanks. Tell us more below or ask the assistant.'
            : vote
              ? 'Thanks for the feedback.'
              : 'Was this helpful?'}
        </span>
        <HelpVoteButtons
          vote={vote}
          onVote={handleVote}
          className={styles.articleFeedbackActions}
        />
      </div>

      {/* PRD: hidden when the AI toggle is off. */}
      {vote === 'down' && aiEnabled && (
        <button
          type='button'
          className={styles.articleFeedbackAsk}
          onClick={() =>
            onAskAssistant(
              `I read "${articleTitle}" and still need help. Can you explain it differently?`
            )
          }
        >
          <span className={styles.helpSearchHandoffIcon}>
            <AiStar color='currentColor' size={16} />
          </span>
          Ask the assistant about this
        </button>
      )}
    </div>
  );
};

export default HelpArticleFeedback;
